import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import * as CryptoJS from "crypto-js";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { AngularFireAnalytics } from "@angular/fire/analytics";

@Component({
  selector: "app-video-series",
  templateUrl: "./video-series.component.html",
  styleUrls: ["./video-series.component.css"],
})
export class VideoSeriesComponent implements OnInit {
  encodeUrl: any;
  constructor(
    public service: BaseService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    public translate: TranslateService,
    public analytics: AngularFireAnalytics
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }
  document: boolean;
  document_id: any;
  public_id: any;
  relatedSeries: any = [];
  videoDetail: any;
  seasons: any = [];
  thumbnails: any;
  show: boolean;
  loading_player = true;
  isTabLoad = false;
  app_constant: any;
  background;
  access: boolean;
  token: any;
  output_url: any;
  isPlaying = false;
  navigationSubscription: any;
  shimmerStatus = {
    relatedvideo: true,
    poster: true,
  };
  redirectUrl: any;
  source = [];
  episode_index: number = 0;
  season_index: number = 0;
  episode_id: number;
  checkedPublic_id: any;
  autoplay = false;
  videoCount = 0;
  customOptionsvideo: OwlOptions = {
    loop: false,
    autoplay: false,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    skip_validateItems: true,
    navText: [
      "<i class='mdi mdi-arrow-left'></i>",
      "<i class='mdi mdi-arrow-right'></i>",
    ],
    responsive: {
      0: {
        items: 2,
      },
      370: {
        items: 2,
      },
      650: {
        items: 3,
      },
      925: {
        items: 4,
      },
      1108: {
        items: 4,
      },
      1257: {
        items: 5,
      },
      1460: {
        items: 6,
      },
    },
    nav: true,
  };
  scrollPosition: any;
  selectedIndex = 0;
  @ViewChild("series", { static: true }) series: ElementRef;
  ngOnInit(): void {
    this.redirectUrl = this.router.url;
    this.app_constant = environment;
    this.navigationSubscription = this.route.params.subscribe((params) => {
      this.public_id = params["public_id"].split("?")[0];
      this.isPlaying = false;
      this.shimmerStatus.poster = true;
      this.shimmerStatus.relatedvideo = true;
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      this.service.SeriesDetailService(this.public_id).subscribe(
        (detail) => {
          detail.results.seasons = detail.results.seasons.filter(
            (el) => el.episodes.length > 0
          );
          this.seasons = detail.results.seasons;
          this.videoDetail = detail.results;
          this.service.likeDislikeStatus = this.videoDetail.is_user_likeDislike;
          this.token = this.videoDetail.access_video_token;
          this.checkVideoStatus();

          this.isPlaying = true;
          this.route.queryParamMap.subscribe((params: any) => {
            if (params.params.watching || params.params.episode) {
              this.autoplay = true;
            }

            if (params.params.episode) {
              let items = this.videoDetail.seasons.map((data) => {
                return data.episodes
                  .map((el) => {
                    return el.public_id;
                  })
                  .indexOf(params.params.episode);
              });
              for (let i = 0; i < items.length; i++) {
                if (items[i] !== -1) {
                  this.selectedIndex = i;
                }
              }
              this.setSeasonData(params);
            } else {
              this.setSeasonData(this.public_id);
            }
          });
          const index = detail.results.thumbnails
            .map((el) => {
              return el.image_type;
            })
            .indexOf("landscape");
          this.thumbnails = detail.results.thumbnails[index].asset;
          this.tabRender();

          if (detail) {
            this.shimmerStatus.relatedvideo = true;
            this.service.relatedSeriesService(this.public_id).subscribe(
              (res) => {
                this.shimmerStatus.relatedvideo = false;
                if (res) {
                  this.relatedSeries = res.results;
                }
              },
              (err) => {
                this.shimmerStatus.relatedvideo = false;
              }
            );
          }
        },
        (err) => {
          this.shimmerStatus.poster = true;
          this.shimmerStatus.relatedvideo = false;
          this.loading_player = false;
          this.toastr.error(err.message, "OOPS!"),
            {
              closeButton: true,
            };
          this.router.navigate(["/home"]);
          // if (err.status === 0) {
          //   this.toastr.error("CONNECTION REFUSED", "OOPS!", {
          //     closeButton: true,
          //   });
          // } else if (err.status === 500) {
          //   this.toastr.error(err.message, "OOPS!", {
          //     closeButton: true,
          //   });
          // } else if (err.status === 404) {
          //   this.toastr.error(err.message, "OOPS!", {
          //     closeButton: true,
          //   });
          // } else if (err.status === 400) {
          //   this.toastr.error(err.message, "OOPS!", {
          //     closeButton: true,
          //   });
          //   this.router.navigate(["/home"]);
          // } else if (err.status === 401) {
          //   this.toastr.error(err.message, "OOPS!", {
          //     closeButton: true,
          //   });
          // } else {
          //   this.toastr.error(err.message, "OOPS!", {
          //     closeButton: true,
          //   });
          // }
        }
      );
    });
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(this.router.url),
      environment.secretkey
    ).toString();
  }

  setSeasonData(params) {
    if (params === this.public_id) {
      if (this.seasons[this.season_index]) {
        if (this.seasons[this.season_index].episodes[this.episode_index]) {
          this.changeEpisode(this.episode_index);
        }
      }
    } else {
      let i: any;
      this.videoDetail.seasons.map((data) => {
        i = data.episodes
          .map((el) => {
            return el.public_id;
          })
          .indexOf(params.params.episode);
        if (i != -1) {
          this.changeEpisode(i);
        }
      });
    }
  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  changeEpisode(index) {
    this.document = false;
    const data = this.seasons[this.selectedIndex].episodes[index];
    this.episode_id =
      this.seasons[this.selectedIndex].episodes[index]?.public_id;
    if (data?.extension === "document") {
      this.shimmerStatus.poster = true;
      this.loading_player = false;
      this.episode_index = index;
      this.season_index = this.selectedIndex;
      this.service.isShow = false;
      this.setData(this.selectedIndex, index);
      this.document_id = data.public_id;
      this.document = true;
    } else {
      this.shimmerStatus.poster = true;
      this.season_index = this.selectedIndex;
      this.loading_player = false;
      this.episode_index = index;
      this.setData(this.selectedIndex, index);
    }
  }
  setData(season_index, episode_index) {
    const data = {
      series_id: this.public_id,
      episode_id:
        this.seasons[season_index]?.episodes[episode_index]?.public_id,
    };
    this.service.accessvideoToken(data).subscribe((token) => {
      this.token = token.access_video_token;
      if (this.token) {
        const sendDtata = {
          token: this.token,
          web: "web",
          partner_id: this.videoDetail.posted_id,
          type: this.videoDetail.type,
        };
        this.service.coockiesPolicyService(sendDtata).subscribe(
          (res) => {
            this.output_url = res.url;
            this.shimmerStatus.poster = false;
            this.loading_player = true;
          },
          (err) => {
            this.shimmerStatus.poster = false;
            this.access = true;
            this.isPlaying = true;
          }
        );
      }
    });
    setTimeout(() => {
      this.shimmerStatus.relatedvideo = false;
      //  this.shimmerStatus.poster= false;
      // this.loading_player = false;
    }, 500);
    setTimeout(() => {
      window.scrollTo(0, 0);
      this.isPlaying = false;
      if (this.seasons[this.season_index]) {
        if (this.seasons[this.season_index].episodes[this.episode_index]) {
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].season_title = this.seasons[this.season_index].title;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].episod_number = this.episode_index;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].series_title = this.videoDetail.title;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].season_number = this.season_index + 1;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].total_like = this.videoDetail.total_like;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].total_dislike = this.videoDetail.total_dislike;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].lastComment = this.videoDetail.lastComment;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].avg_rating = this.videoDetail.avg_rating;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].total_comment = this.videoDetail.total_comment;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].is_remindMe = this.videoDetail.is_remindMe;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].is_favorite = this.videoDetail.is_favorite;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].is_user_likeDislike = this.service.likeDislikeStatus;
          // this.seasons[this.season_index].episodes[
          //   this.episode_index
          // ].output_url = this.output_url;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].is_user_rating_review_status =
            this.videoDetail.is_user_rating_review_status;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].season_id = this.seasons[this.season_index].public_id;
          this.seasons[this.season_index].episodes[
            this.episode_index
          ].series_id = this.public_id;
        }
      }
    }, 100);
  }
  tabRender() {
    this.checkedPublic_id = this.videoDetail.public_id;
    this.isTabLoad = false;
    setTimeout(() => {
      this.isTabLoad = true;
    }, 0);
  }
  videoStatus(event) {
    if (event.videoStatus == "error") {
      this.loading_player = false;
    }
    this.isPlaying = event.isPlaying;
    this.videoCount++;
    // this.isPlaying === true
    //   ? this.analytics.logEvent("Video_Series_Start", {
    //       video_event: "start",
    //       user_id: this.service.encryptedData.id,
    //       video_id: this.seasons?.public_id,
    //       video_title: this.seasons?.title,
    //       video_position: 0,
    //       video_duration: this.seasons?.duration,
    //       video_progress: 0,
    //       debug_mode: true,
    //     })
    //   : this.analytics.logEvent("Video_Series_Stop", {
    //       video_event: "stop",
    //       user_id: this.service.encryptedData.id,
    //       video_id: this.seasons?.public_id,
    //       video_title: this.seasons?.name,
    //       video_position: 0,
    //       video_duration: this.seasons?.duration,
    //       video_progress: 0,
    //       debug_mode: true,
    //     });
    event?.videoStatus === "start" && this.videoCount === 1
      ? this.analytics.logEvent("video_playback", {
          video_event: "start",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: 0,
          video_duration: event?.totalDuration,
          video_progress: 0,
          debug_mode: true,
        })
      : event?.videoStatus === "ended"
      ? this.analytics.logEvent("video_playback", {
          video_event: "end",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: 0,
          video_duration: event?.viewDuration,
          video_progress: event?.totalDuration,
          debug_mode: true,
        })
      : event?.videoStatus === "pause" && this.videoCount === 2
      ? this.analytics.logEvent("video_playback", {
          video_event: "pause",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: event?.viewDuration,
          video_duration: this.videoDetail?.duration,
          video_progress: (event?.viewDuration / this.videoDetail?.duration)*100,
          debug_mode: true,
        })
      : event?.videoStatus === "pause" && this.videoCount > 2
      ? this.analytics.logEvent("video_playback", {
          video_event: "resume",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: event?.viewDuration,
          video_duration: this.videoDetail?.duration,
          video_progress: (event?.viewDuration / this.videoDetail?.duration)*100,
          debug_mode: true,
        })
      : "";
  }
  checkVideoStatus() {
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.videoDetail.is_login_required === "yes") {
      if (encryptedData) {
        if (this.videoDetail.is_access === "free") {
          this.videoDetail.videoStatus = true;
        } else {
          if (this.videoDetail.is_user_content_purchase === "yes") {
            this.videoDetail.videoStatus = true;
          } else {
            this.videoDetail.bannerStatus = true;
            this.shimmerStatus.poster = false;
            this.loading_player = true;
          }
        }
      } else {
        this.router.navigate(["/login"], {
          queryParams: { public_id: this.encodeUrl },
        });
      }
    } else {
      this.videoDetail.videoStatus = true;
    }
  }
}
